import { TadaAyanaAPI } from ".";

export default {
  getPropertyAll() {
    return TadaAyanaAPI.get("/property/all?lang=EN");
  }
};
